const actions = {
    SUPPLIERGROUP_DETAILS_START:'SUPPLIERGROUP_DETAILS_START',
    SUPPLIERGROUP_DETAILS_SUCCESS:'SUPPLIERGROUP_DETAILS_SUCCESS',
    SUPPLIERGROUP_DETAILS_FAILURE:'SUPPLIERGROUP_DETAILS_FAILURE',

    CLEAR_PURCHASE_SETUP_DETAILS_START: 'CLEAR_PURCHASE_SETUP_DETAILS_START',
    CLEAR_PURCHASE_SETUP_DETAILS_SUCCESS: 'CLEAR_PURCHASE_SETUP_DETAILS_SUCCESS'
};

export default actions;